import { render, staticRenderFns } from "./ProductFooter.vue?vue&type=template&id=5255f5fe&scoped=true&"
import script from "./ProductFooter.vue?vue&type=script&lang=js&"
export * from "./ProductFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProductFooter.vue?vue&type=style&index=0&id=5255f5fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255f5fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
